"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("@material-ui/icons/utils/createSvgIcon"));

var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));

var _core = require("@material-ui/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var useStyles = (0, _core.makeStyles)(function () {
  return (0, _core.createStyles)({
    notSquare: {
      height: '1em',
      width: 'auto'
    }
  });
});
var create = 24 !== 24 || 24 !== 24 ? function (props) {
  var _props$classes = props.classes,
      classes = _props$classes === void 0 ? {} : _props$classes,
      otherProps = _objectWithoutProperties(props, ["classes"]);

  var styles = useStyles();

  var newClasses = _objectSpread({}, classes, {
    root: styles.notSquare + ' ' + (classes.root || '')
  });

  return _react["default"].createElement(_SvgIcon["default"], _extends({
    viewBox: '0 0 ' + 24 + ' ' + 24,
    classes: newClasses
  }, otherProps), _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement("path", {
    d: "M20 15.67V14h2v-4h-2V8.33A1.34 1.34 0 0018.67 7H3.34A1.34 1.34 0 002 8.33v7.33A1.34 1.34 0 003.33 17h15.34A1.34 1.34 0 0020 15.67z"
  }), _react["default"].createElement("path", {
    d: "M20 15.67V14h2v-4h-2V8.33A1.34 1.34 0 0018.67 7H3.34A1.34 1.34 0 002 8.33v7.33A1.34 1.34 0 003.33 17h15.34A1.34 1.34 0 0020 15.67z"
  }), _react["default"].createElement("path", {
    fill: "none",
    d: "M24 0v24H0V0z"
  })));
} : (0, _createSvgIcon["default"])(_react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement("path", {
  d: "M20 15.67V14h2v-4h-2V8.33A1.34 1.34 0 0018.67 7H3.34A1.34 1.34 0 002 8.33v7.33A1.34 1.34 0 003.33 17h15.34A1.34 1.34 0 0020 15.67z"
}), _react["default"].createElement("path", {
  d: "M20 15.67V14h2v-4h-2V8.33A1.34 1.34 0 0018.67 7H3.34A1.34 1.34 0 002 8.33v7.33A1.34 1.34 0 003.33 17h15.34A1.34 1.34 0 0020 15.67z"
}), _react["default"].createElement("path", {
  fill: "none",
  d: "M24 0v24H0V0z"
})), 'Battery');
var _default = create;
exports["default"] = _default;